// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"a8737201","308":"638f743e","395":"4101e5e7","453":"fe3b160c","617":"178dc711","786":"54810044","861":"0e16375b","866":"04c3547e"}[chunkId] + ".chunk.js";
};